import { toast } from 'sonner';
import { useEffect } from 'react';

import { Button } from '@shared/components/ui/button';

import { useAppUpdate } from '@features/app-update/hooks/use-app-update';

/**
 * Invisible component: shows a persistent toast inviting the user to reload when a new version is deployed.
 */
export const AppUpdateNotifier = () => {
  const updateAvailable = useAppUpdate();

  useEffect(() => {
    if (!updateAvailable) {
      return;
    }

    toast.info('Une nouvelle version est disponible', {
      id: 'app-update',
      duration: Infinity,
      action: (
        <Button className="mr-3 ml-auto shrink-0 whitespace-nowrap" onClick={() => window.location.reload()} size="sm">
          Recharger
        </Button>
      ),
    });
  }, [updateAvailable]);

  return null;
};
